"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _getAlias = _interopRequireDefault(require("@devsta/get-alias"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n{\n  getOrganisationInvite(alias: \"", "\") {\n    user {\n      ... on EmptyUser {\n        email\n      }\n      ... on User {\n        userId\n        firstName\n        lastName\n        email\n        phoneNumber\n        workNumber\n        linkedInUrl\n        officeLocation\n        department\n        jobTitle\n        imageUrl,\n        initialSetup\n      }\n    }\n    organisation {\n      name,\n      organisationId,\n      imageUrl\n    }\n    teamId\n  }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var alias = (0, _getAlias.default)();

var _default = (0, _graphqlTag.default)(_templateObject(), alias);

exports.default = _default;